import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Config } from '../../config/config';
import { CauHinhCoQuanService } from '../he-thong/cau-hinh-co-quan/cau-hinh-co-quan.service';
import { CauHinhCoQuan } from '../he-thong/cau-hinh-co-quan/cau-hinh-co-quan';
import { SignalRService } from 'app/services/signalR.service';

@Component({
    selector: 'logout',
    template: 'Đang đang xuất',
    providers: [CauHinhCoQuanService]
})
export class LogoutComponent implements OnInit {
    constructor(private router: Router,
        private authService: AuthService,
        private signalRService: SignalRService,
        private cauhinhService: CauHinhCoQuanService) { }

    detailItem: CauHinhCoQuan;

    ngOnInit() {
        this.authService.isLoggedIn = false;
        this.signalRService.disconnected();
        var id_token = localStorage.getItem("scnnttidtoken");
        localStorage.clear();
        // var url = Config.sso_logout + "&id_token_hint=" + id_token;
        var url = this.authService.systemConfig.sso.sso_logout + Config.appUrl + '/login&id_token_hint=' + id_token;
        this.cauhinhService.GetOTP().subscribe(
            (data) => {
                if (!data || data.length <= 0) {

                } else {
                    this.detailItem = data;
                    if (this.detailItem.SSO && id_token !== null) {
                        window.location.href = url;
                    } else {
                        this.router.navigate(['login']);
                    }
                }
            },
            er => {

            });
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/logout/logout.component.ts